import React, { useContext, useEffect, useState } from 'react'
import "./observations.css"
import MaterialTable from 'material-table'
import { ThemeProvider, createTheme } from "@mui/material";
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FaPlusSquare,
  FaCheck,
  FaChevronLeft,
  FaChevronRight,
  FaTimes,
  FaTrash,
  FaEdit,
  FaFilter,
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaMinus,
  FaSave,
  FaSearch,
  FaThList,
  FaRegEdit,
} from "react-icons/fa";
import { SiMicrosoftexcel } from "react-icons/si";

import Select from 'react-select';
import { Url } from '../../../constants/ApiUrlConstants';
import { GET, PUT } from '../../Common/HttpMethods/HttpMethods';
import { contextData } from '../../../context/ContextProvider';
import { BsSearch } from 'react-icons/bs';
import FailModal from '../../Common/Popups/FailModal';
import DownloadModal from '../../Common/Popups/DownloadModal';
import { DownloadExcel } from '../../Common/ExcelDownload/DownloadExcel';
import { createTableIcons, CustomYearPicker, getDepartmentLabel, getPeriodLabels } from '../../CommonCase/CommonFunctions';


export const handlePageChange = (setToggle,toggle) => {
  setToggle(!toggle)
};

export const birthYearChange = (date, setBirthYearForCalender, setYear) => {
  setBirthYearForCalender(date);
  setYear({
    label: date.getFullYear(),
    value: date.getFullYear()
  });
};

export const handleFinalEditProcedure = async (editProcedure, setLoading,token,handleCloseEditProcedure, getObservationData, setSearchInput, setFailMessage, setSessionExpiredModal) => {
  let validData = true;

  editProcedure?.data?.evidences.forEach((i) => {
    if (!i.isValid) {
      validData = false;
    } else if (!i.isValidAction) {
      validData = false;
    } else if (!i.isValidComment) {
      validData = false;
    }
  });

  console.log("VVVVVVVVVVVVVVVVVVVVVVVVVVV", validData);

  if (validData) {
    setLoading(true);
    const { evidences, frequency, action, comments, controlRefId, auditProcessId } = editProcedure.data;
    const evidenceToSend = evidences.map((item) => {
      return {
        "observationId": item?.observationId,
        "evidences": item.evidence,
        "complainceStatus": item?.complainceStatus,
        "comments": item?.comments,
        "remediationAction": item?.remediationAction,
        "auditTestProcId": item?.auditTestProcId
      };
    });

    const procedureDataToSend = {
      "auditObservationList": [...evidenceToSend]
    };

    const editObservationResponse = await PUT(Url?.updateObservationList, token, procedureDataToSend);

    if (editObservationResponse?.SUCCESS) {
      
      handleCloseEditProcedure();
      getObservationData();
      setSearchInput("");
    } else if (editObservationResponse?.STATUS == 401) {
      setLoading(false);
      setFailMessage("Failed to edit observation");
      setSessionExpiredModal(true);
    } else {
      setLoading(false);
    }
  }
}

export const handleEditProcedureClick = (rowData, index, fieldName, i,setEditProcedure) => {

  const { auditTestProcedureList } = rowData;

  let objectToSet = {
    evidences: [],
    frequency: rowData?.frequency,
    action: rowData?.remediationAction,
    comments: rowData?.comments,
    controlRefId: rowData?.controlRefId,
    auditProcessId: rowData?.auditProcessId
  };

  auditTestProcedureList?.forEach((row, index) => {
    const evidence = {
      [`ev${index}`]: index,
      evidence: row?.evidences,
      observationId: row?.observationId,
      complainceStatus: row?.complainceStatus,
      auditTestProcId: row?.auditTestProcId,
      remediationAction: row?.remediationAction,
      comments: row?.comments,
      isValid: true,
      isValidAction: true,
      isValidComment: true
    };
    objectToSet.evidences.push(evidence);
  });

  switch (fieldName) {
    case "CompStatus":
    case "Evidence":
    case "RemAction":
    case "Comments":
      setEditProcedure(() => {
        return {
          isEditClicked: true,
          indexToEdit: index,
          auditTestProcId: i?.auditTestProcId,
          data: objectToSet,
          field: fieldName
        };
      });
      break;
    default:
      break;
  }
};



export const handleNavigate = (navigate) => {
  navigate("/main/audit/calendar")
}

export const validateInput = (val) => {
  if (val == "") {
    return true
  }
  else {
    return /^[^\s]/.test(val)
  }
}

export const customStylesyear = {
  option: (provided, state) => ({
    ...provided,
    color: "black",
    backgroundColor: state.isSelected ? "#00ADEE" : "white",
    padding: 10,
    zIndex: 9999,
    height: 20,
    display: "flex",
    alignItems: "center",
    fontSize: 13,
    cursor: "pointer",
  }),
  menu: (provided, state) => ({
    ...provided,
    width: "100%",
    innerHeight: "22px",
    padding: 0,
    position: "absolute",
    zIndex: 9999,
    display: "block",
    top: 22,
    cursor: "pointer",
  }),
  control: (provided, state) => ({
    border: "1px solid #999999",
    borderRadius: 5,
    height: 25,
    width: 95,
    fontSize: 13,
    display: "flex",
    cursor: "pointer",
    "&:focus": {
      outline: "none",
      boxShadow: "none",
    },
  }),
  indicatorSeparator: () => ({
    display: 'none' // Hide the indicator separator
  }),
};

export const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color: "black",
    backgroundColor: state.isSelected ? "#00ADEE" : "white",
    padding: 10,
    zIndex: 9999,
    height: 20,
    display: "flex",
    alignItems: "center",
    fontSize: 13,
    cursor: "pointer",
  }),
  menu: (provided, state) => ({
    ...provided,
    width: "100%",
    innerHeight: "22px",
    padding: 0,
    position: "absolute",
    zIndex: 9999,
    display: "block",
    top: 22,
    cursor: "pointer",
  }),
  control: (provided, state) => ({
    border: "1px solid #999999",
    borderRadius: 5,
    height: 25,
    width: 115,
    fontSize: 13,
    display: "flex",
    cursor: "pointer",
    "&:focus": {
      outline: "none",
      boxShadow: "none",
    },
  }),
  indicatorSeparator: () => ({
    display: 'none' // Hide the indicator separator
  }),
};

export const customStyles3 = {
  control: (provided) => ({
    border: "1px solid #999999",
    borderRadius: 5,
    height: 25,
    fontSize: 13,
    width: 186,
    display: "flex",
    cursor: "pointer",
    "&:focus": {
      outline: "none",
      boxShadow: "none",
    },
  }),
  option: (provided, state) => ({

    ...provided,
    color: "black",
    backgroundColor: state.isSelected ? "#00ADEE" : "white",
    padding: 10,
    zIndex: 9999,
    height: 20,
    display: "flex",
    alignItems: "center",
    fontSize: 13,
    cursor: "pointer",

  }),
  menu: (provided) => ({
    // ...provided,
    //  maxHeight: '120px',
    ...provided,
    width: "100%",
    innerHeight: "22px",
    padding: 0,
    position: "absolute",
    zIndex: 9999,
    display: "block",
    top: 22,
    cursor: "pointer",
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: '120px',
    overflowY: 'auto',
  }),
  indicatorSeparator: () => ({
    display: 'none' // Hide the indicator separator
  }),
};

export const customStyles1 = {
  ...customStyles,
  option: (provided, state) => ({
    ...provided,
    height: 28,
    width: "100%",
  }),
  menu: (provided, state) => ({
    ...provided,
    width: "100%",
  }),
}




export const handleEditchange = (fieldName, value, editProcedure, validateInput, setEditProcedure) => {
  switch (fieldName) {
    case "evidances":
      const arr = [...editProcedure.data.evidences]
      let validate = validateInput(value.evidance)
      arr[value?.evIndex] = { ...arr[value?.evIndex], [`ev${value.evIndex}`]: value.evIndex, evidence: value.evidance, observationId: value?.observationId, isValid: validate };
      setEditProcedure((prevState) => {
        return { ...prevState, data: { ...prevState?.data, evidences: arr } }
      })
      break;
    case "action":
      const arr1 = [...editProcedure.data.evidences]
      let validateAct = validateInput(value.action)
      arr1[value?.evIndex] = { ...arr1[value?.evIndex], [`ev${value.evIndex}`]: value.evIndex, remediationAction: value.action, observationId: value?.observationId, isValidAction: validateAct };
      setEditProcedure((prevState) => {
        return { ...prevState, data: { ...prevState?.data, evidences: arr1 } }
      })
      break;
    case "comments":
      const arr3 = [...editProcedure.data.evidences]
      let validateComment = validateInput(value.comment)

      arr3[value?.evIndex] = { ...arr3[value?.evIndex], [`ev${value.evIndex}`]: value.evIndex, comments: value.comment, observationId: value?.observationId, isValidComment: validateComment };
      setEditProcedure((prevState) => {
        return { ...prevState, data: { ...prevState?.data, evidences: arr3 } }
      })
      break;
    case "frequency":
      setEditProcedure((prevState) => {
        return { ...prevState, data: { ...prevState?.data, [fieldName]: value } }
      })
      break;
    case "complainceStatus":
      const arr2 = [...editProcedure.data.evidences]
      arr2[value?.evIndex] = { ...arr2[value?.evIndex], complainceStatus: value?.complainceStatus };
      setEditProcedure((prevState) => {
        return { ...prevState, data: { ...prevState?.data, evidences: arr2 } }
      })
      break;
  }
}


// Exporting handleSessionExpClose with dependency injection for testability
export const handleSessionExpClose = (navigate, setActive) => {
  sessionStorage.clear();
  navigate('/login');
  setActive('tab1');
};

// Exporting closeDownloadModal with dependency injection for testability
export const closeDownloadModal = (setDownloadAudit, setOpenDownloadModal) => {
  setDownloadAudit(false);
  setOpenDownloadModal(false);
};
// DownloadExcel, dept, year, period, setLoading, closeDownloadModal
// Exporting handleDownloadButton with dependency injection for testability
export const handleDownloadButton = (DownloadExcel, dept, year, period, setLoading, closeDownloadModal,setDownloadAudit, setOpenDownloadModal) => {
  setLoading(true);
  DownloadExcel(dept?.value, year?.value, period?.value)
    .then(() => {
      setLoading(false);
    })
    // .catch(() => {
    //   setLoading(false);
    // });
    closeDownloadModal(setDownloadAudit, setOpenDownloadModal);
};

// Exporting handleOpenDownloadModal with dependency injection for testability
export const handleOpenDownloadModal = (setDownloadAudit, setOpenDownloadModal, setFailMessage) => {
  setDownloadAudit(true);
  setOpenDownloadModal(true);
  setFailMessage("Are you sure you want to download?");
};


export const fetchData = async (location, setDept, setYear, setPeriod, setDisableDropdown, setYearList, setFailMessage, setLoading, setSessionExpiredModal, token) => {
  let data = location.state;
  if (data) {
    setDept(data.dept);
    setYear(data.year);
    setPeriod(data.quarter);
    setDisableDropdown(true);
  } else {
    try {
      const getYear = await GET(Url?.getAuditYear, token);
      if (getYear.SUCCESS) {
        if (getYear?.MESSAGE) {
          setLoading(false);
          setFailMessage(getYear?.MESSAGE);
        }
        let yearData = getYear?.DATA?.yearList?.map((i) => {
          return { label: i, value: i };
        });
        let departmentLabel = getDepartmentLabel(getYear?.DATA?.latestDepartTag);
        let periodLabels = getPeriodLabels(getYear?.DATA?.latestQuarter);

        setYearList(yearData);
        setYear({
          label: getYear?.DATA?.latestYear,
          value: getYear?.DATA?.latestYear
        });
        setDept({
          label: departmentLabel,
          value: getYear?.DATA?.latestDepartTag
        });
        setPeriod({
          label: periodLabels,
          value: getYear?.DATA?.latestQuarter
        });
      } else if (getYear?.STATUS == 401) {
        setLoading(false);
        setSessionExpiredModal(true);
        setFailMessage("Session expired");
      }else if (getYear?.STATUS == 400) {
        setLoading(false);
        setSessionExpiredModal(true);
        setFailMessage("Session expired");
      }else if (getYear?.STATUS == 403) {
        setLoading(false);
        setSessionExpiredModal(true);
        setFailMessage("Session expired");
      }else if (getYear?.STATUS == 404) {
        setLoading(false);
        setSessionExpiredModal(true);
        setFailMessage("Session expired");
      }else if (getYear?.STATUS == 500) {
        setLoading(false);
        setSessionExpiredModal(true);
        setFailMessage("Session expired");
      }else{
        setLoading(false);
        setSessionExpiredModal(true);
        setFailMessage("something is wrong.");
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }
};

export  const adjustTextareaHeight = () => {
  let addStep = document.getElementsByClassName("obs-table-textarea");
  if ([...addStep]) {
    [...addStep].forEach((item, index) => {
      item.style.height = "auto";
      item.style.height = item.scrollHeight + 'px';
    });
  }
}


const Observations = () => {
  const token = sessionStorage.getItem("TOKEN");

  const theme = createTheme();
  const { setLoading, setActive } = useContext(contextData);
  const [disableDownload, setDisableDownload] = useState(false)
  const navigate = useNavigate();

  const location = useLocation();

  let d = new Date()

  const customStyles2 = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };
 
  
  let SelectOpt = [
    {
      label: "In Scope",
      value: "YES",
    },
    {
      label: "Not In Scope",
      value: "NO",
    }
  ]
  const [data, setData] = useState([]);
  const [dataCopy, setCopyData] = useState([]);

  const [toggle, setToggle] = useState(false)

  const [searchInput, setSearchInput] = useState("")

  const [failMessage, setFailMessage] = useState("");

  const [sessionExpiredModal, setSessionExpiredModal] = useState(false)

  const [openMsgModal, setOpenMsgModal] = useState(false)

  const [openDownloadModal, setOpenDownloadModal] = useState(false);

  const [successMessage, setSuccessMessage] = useState("")

  const [donwloadAudit, setDownloadAudit] = useState(false)

  const [downloadOpt, setDownoadOpt] = useState(0);

  const [dept, setDept] = useState({
    label: "HR",
    value: 1,
  })

  const [selectedRef, setSelectedRef] = useState();
  const [indexForEdit, setIndexForEdit] = useState(
    {
      index: "",
      refId: ""
    }
  );
  const [editProcedure, setEditProcedure] = useState({
    indexToEdit: null,
    isEditClicked: false,
    auditTestProcId: null,
    field: "",
    data: {
      evidences: [],
      frequency: "",
      action: "",
      comments: "",
      controlRefId: null,
      auditProcessId: null
    }
  })

  const [year, setYear] = useState({
    label: `${d.getFullYear()}`,
    value: `${d.getFullYear()}`,
  });


  const [yearList, setYearList] = useState([])

  const [period, setPeriod] = useState({ value: 'Quarter 1', label: 'Q1 (January - March)' },);


  const [disableDropdown, setDisableDropdown] = useState(false);



  let options = [
    {
      label: "HR",
      value: 1,
    },
    {
      label: "Governance",
      value: 2,
    },
    {
      label: "IT",
      value: 3,
    },
    {
      label: "Facillity",
      value: 4,
    }
  ]


  const periodOptions = [

    { value: 'Quarter 1', label: 'Q1 (April - June)' },
    { value: 'Quarter 2', label: 'Q2 (July - September)' },
    { value: 'Quarter 3', label: 'Q3 (October - December)' },
    { value: 'Quarter 4', label: 'Q4 (January - March)' },
  ];


  useEffect(() => {
    fetchData(location, setDept, setYear, setPeriod, setDisableDropdown, setYearList, setFailMessage, setLoading, setSessionExpiredModal, token);
  }, []);


  useEffect(() => {
    adjustTextareaHeight()
  }, [editProcedure])

  useEffect(() => {
    getObservationData()
  }, [dept, year, period])

  useEffect(() => {
    const headcontainer = document.getElementById("testing-procedure-title");
    headcontainer.parentElement.style.width = "100%";

    const testProcContainer = document.getElementsByClassName("test-procedure");
    [...testProcContainer].forEach((item) => {
      item.parentElement.style.padding = "0px";
    });
  }, [data, toggle]);


  useEffect(() => {
    if (searchInput == "") {
      setData(dataCopy)
    }
    else {
      let a = dataCopy
      setData(dataCopy.filter((item) => `${item.controlRefNo}`.includes(searchInput)));
    }
  }, [searchInput])

  



  // ==========================================================================================================Handle Edit Clicked Functionallity=============================================================
 
  const handleCloseEditProcedure = () => {
    setEditProcedure({
      indexToEdit: null,
      isEditClicked: false,
      data: {
        evidences: [],
        frequency: "",
        action: "",
        comments: "",
        controlRefId: null,
        auditProcessId: null
      }
    })
  }


  // ==========================================================================================================Handle Edit Change Functionallity=============================================================

  const titleStyle = {
    // borderRight: '1px solid gray',
  }

  const dataStyle = {
    // borderRight: '1px solid gray',
    fontWeight: "600",
    color: "black",
  }
  const color = "#00ADEE"
  const tableHeaderStyle = {
    backgroundColor: "#E2F7FF",
    color: "#00ADEE",
    fontWeight: "bold",
    height: 35,

  };

  const tableIconsObs = createTableIcons();





  const columns = [
    {
      title: <p>CONTROL REFERENCE</p>,
      field: "controlReference",
      sorting: false,
      render: (rowData) => {
        return (
          <div style={{ ...dataStyle, paddingLeft: "10px", position: "relative", textAlign: 'right', paddingRight: '5px' }} className="obs-table-row-data obs-ref-no">
            <p>{rowData?.controlRefNo}</p>
            {rowData?.controlRefShort &&
              <div className='cref-number-tooltip'>
                {rowData?.controlRefShort}
              </div>}
          </div>
        );
      },
    },
    {
      title: <p>CONTROL OBJECTIVE</p>,
      field: "controlObjective",
      sorting: false,
      render: (rowData) => {
        return (
          <div style={titleStyle} className="obs-table-row-data">
            <p>{rowData?.controlObject}</p>
          </div>
        );
      },
    },
    {
      title: <p>CONTROL DESCRIPTION</p>,
      field: "controlDescription",
      sorting: false,
      render: (rowData) => {

        return (
          <div style={titleStyle} className="obs-table-row-data">
            <p>{rowData?.controlDescription}</p>
          </div>
        );
      },
    },
    {
      title: <p>RESPONSIBLE DEPARTMENT</p>,
      field: "department",
      sorting: false,
      render: (rowData) => {

        return (
          <div style={titleStyle} className="obs-table-row-data">
            <p>{rowData?.deptartmentTagMaster?.deptTag}</p>
          </div>
        );
      },
    },
    {
      title: <p>FREQUENCY</p>,
      field: "freq",
      sorting: false,
      render: (rowData) => {

        return (
          <div style={titleStyle} className="obs-table-row-data">
            <div style={{ height: "100%", fontSize: 13, display: "flex", alignItems: "center", justifyContent: "left", padding: "0 2px" }}>

              <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "left", gap: 5, marginBottom: 3 }}>
                <div style={{ display: "flex" }}>
                  <p style={{}}>{rowData?.frequency ? rowData?.frequency : "Not available"}</p>
                </div>
              </div>
              {/* } */}
            </div>
          </div>
        );
      },
    },
    {
      title: <div id="testing-procedure-title" className='testing-procedure-heading' style={{ width: "100%" }}> <p>Testing Procedure</p> <p>Compliance Status</p> <p>Evidences</p> <p>Remediation Action</p> <p>Comments</p> </div>,
      field: "testingProcedure",
      render: (rowData) => {
        return (
          rowData?.auditTestProcedureList?.map((i, index) => {
            return (
              <div class='test-procedure' style={{ display: "grid", gridTemplateColumns: " 23% 11% 20% 23% 23%", alignItems: "flex-start", justifyContent: "space-between", borderBottom: index + 1 !== rowData?.auditProcedureList?.length ? "1px solid #E0E0E0" : "" }}>
                {/* <div style={{ borderRight: "1px solid #00000040", fontSize: 13, height: "100%", display: "flex", alignItems: "center", padding: "5px" }}>{i?.testingProcedure}</div> */}
                <div style={{ borderRight: "1px solid #00000040", fontSize: 13, height: "100%", display: "flex", alignItems: "center", padding: "5px" }}>
                  <div className="test_procedure-text">
                    <div className="test_proc_index">{index + 1}.</div>
                    <div className="test_proc_text">
                      {i?.testingProcedure}
                    </div>
                  </div>
                </div>
                {/* ============================================================================CompStatus tab============================================================================= */}
                <div
                  onBlur={() => handleFinalEditProcedure(editProcedure, setLoading,token,handleCloseEditProcedure, getObservationData, setSearchInput, setFailMessage, setSessionExpiredModal)}
                  onClick={() => { handleEditProcedureClick(rowData, index, "CompStatus", i, setEditProcedure); }}
                  style={{ borderRight: "1px solid #00000040", height: "100%", fontSize: 13, display: "flex", alignItems: "center", justifyContent: "center", alignSelf: "center", }}
                >

                  {
                    (editProcedure?.isEditClicked && editProcedure?.indexToEdit == index && editProcedure?.auditTestProcId == i?.auditTestProcId && editProcedure?.field == "CompStatus") ?

                      <div class="status-select-container" style={{ width: "90%", }} onClick={(e) => e.stopPropagation()}>
                        <Select
                          options={SelectOpt}
                          value={{ label: editProcedure.data?.evidences[index]?.complainceStatus ? "In Scope" : "Not In Scope", value: editProcedure.data?.evidences[index]?.complainceStatus ? "YES" : "NO", }}
                          onChange={(status) => { console.log("status:", status); handleEditchange("complainceStatus", { evIndex: index, complainceStatus: status?.value == "YES" ? true : false }, editProcedure, validateInput, setEditProcedure) }}
                          styles={customStyles1}
                          isSearchable={false}
                        />
                      </div>
                      :
                      <div className='obs-comp-div'>
                        <div className="obs-comp-edit-icon">
                          <span >
                            <FaRegEdit fill="#00ADEE" size={"10px"} />
                          </span>
                        </div>
                        {console.log('i?.complainceStatus===========', i?.complainceStatus)}
                        <p style={{ textAlign: "left", width: "100%", padding: 5 }}>
                          {i?.complainceStatus === true ? "In Scope" : i?.complainceStatus === false ? "Not In Scope" : "Not Available"}
                        </p>


                      </div>
                  }
                  {/* <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "left", gap: 5, marginBottom: 3 ,position:'relative'}}>
                        
                        <div style={{ display: "flex", width: "98%", }} className='obs-table-para' >
                        <div className="obs-edit-icon">
                          <span >
                            <FaRegEdit fill="#00ADEE" size={"10px"} />
                          </span>
                        </div>
                          <p  style={{reSize:"none", minHeight:"39px",display:'flex', alignItems:'center'}} >{i?.evidences ? i?.evidences : "Not available"}</p>
                        </div>
                      </div> */}

                  {/* <div className='EditAddObsField'>
                    {console.log('editProcedure?.isEditClicked===============>>>>>>>>>>>..', editProcedure?.isEditClicked)}
                    {(editProcedure?.isEditClicked == true && editProcedure?.indexToEdit == index && editProcedure?.auditTestProcId == i?.auditTestProcId && editProcedure?.field == "CompStatus") ?
                      <> <button className='obs-actions' onClick={() => { handleCloseEditProcedure() }}><AiOutlineClose size={"14px"} /></button>
                        <button className='obs-actions' onClick={() => { handleFinalEditProcedure() }}><FaPlus size={"14px"} /></button>
                      </>
                      :
                      <button className='obs-actions' onClick={() => { handleEditProcedureClick(rowData, index, "CompStatus", i); }}><SlPencil size={"14px"} /></button>
                    }
                  </div> */}
                </div>
                {/* ============================================================================Evidence tab============================================================================= */}
                <div onBlur={() => handleFinalEditProcedure(editProcedure, setLoading,token,handleCloseEditProcedure, getObservationData, setSearchInput, setFailMessage, setSessionExpiredModal)}
                 onClick={() => { handleEditProcedureClick(rowData, index, "Evidence", i, setEditProcedure); }}  style={{ height: "100%", fontSize: 13, display: "flex", alignItems: "center", justifyContent: "left", padding: "5px", borderRight: "1px solid #00000040" }}>
                  {
                    (editProcedure?.isEditClicked && editProcedure?.indexToEdit == index && editProcedure?.auditTestProcId == i?.auditTestProcId && editProcedure?.field == "Evidence") ?
                      <div style={{ width: "100%", display: "flex", alignItems: "center", marginBottom: 3, flexDirection: "column" }}>
                        <textarea className='obs-table-textarea'
                          // value={editProcedure.data?.evidences[index].evidence}
                          placeholder='Enter Evidences'
                          style={{ width: "100%", resize: "none", boxShadow: "inset rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, inset rgba(60, 64, 67, 0.15) 0px 1px 3px 1px", border: '1px solid #00ADEE' }}
                          onChange={(e) => handleEditchange("evidances", { evidance: e.target.value, evIndex: index, observationId: i?.observationId }, editProcedure, validateInput, setEditProcedure)}
                        >
                          {editProcedure.data?.evidences[index].evidence}
                        </textarea>
                        {!editProcedure.data?.evidences[index]?.isValid && <div style={{ color: "red", textAlign: "left", alignSelf: "flex-start" }}>Input cannot have leading whitespace</div>}
                      </div>
                      :
                      <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "left", gap: 5, marginBottom: 3, position: 'relative' }}>

                        <div style={{ display: "flex", width: "98%", }} className='obs-table-para' >
                          <div className="obs-edit-icon">
                            <span >
                              <FaRegEdit fill="#00ADEE" size={"10px"} />
                            </span>
                          </div>
                          <p style={{ reSize: "none", minHeight: "39px", display: 'flex', alignItems: 'center' }} >{i?.evidences ? i?.evidences : "Not available"}</p>
                        </div>
                      </div>
                  }
                  {/* <div className='EditAddObsField'>
                    {console.log('editProcedure?.isEditClicked===============>>>>>>>>>>>..', editProcedure?.isEditClicked)}
                    {(editProcedure?.isEditClicked == true && editProcedure?.indexToEdit == index && editProcedure?.auditTestProcId == i?.auditTestProcId && editProcedure?.field == "Evidence") ?
                      <> <button className='obs-actions' onClick={() => { handleCloseEditProcedure() }}><AiOutlineClose size={"14px"} /></button>
                        <button className='obs-actions' onClick={() => { handleFinalEditProcedure() }}><FaPlus size={"14px"} /></button>
                      </>
                      :
                      <button className='obs-actions' onClick={() => { handleEditProcedureClick(rowData, index, "Evidence", i); }}><SlPencil size={"14px"} /></button>
                    }
                  </div> */}
                </div>
                {/* ============================================================================RemAction tab============================================================================= */}
                <div onBlur={() => handleFinalEditProcedure(editProcedure, setLoading,token,handleCloseEditProcedure, getObservationData, setSearchInput, setFailMessage, setSessionExpiredModal)}
                onClick={() => handleEditProcedureClick(rowData, index, "RemAction", i,setEditProcedure) }  style={{ height: "100%", fontSize: 13, display: "flex", alignItems: "center", justifyContent: "left", padding: "5px", borderRight: "1px solid #00000040" }}>
                  {
                    (editProcedure?.isEditClicked && editProcedure?.indexToEdit == index && editProcedure?.auditTestProcId == i?.auditTestProcId && editProcedure?.field == "RemAction") ?
                      <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 3, flexDirection: "column" }}>
                        <textarea className='obs-table-textarea' style={{ width: "100%", resize: "none", boxShadow: "inset rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, inset rgba(60, 64, 67, 0.15) 0px 1px 3px 1px", border: '1px solid #00ADEE' }} placeholder='Enter Remediation Action' onChange={(e) => handleEditchange("action", { action: e.target.value, evIndex: index, observationId: i?.observationId }, editProcedure, validateInput, setEditProcedure)}>{editProcedure.data?.evidences[index].remediationAction}</textarea>
                        {!editProcedure.data?.evidences[index]?.isValidAction && <div style={{ color: "red", textAlign: "left", alignSelf: "flex-start" }}>Input cannot have leading whitespace</div>}

                      </div>
                      :
                      <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "left", gap: 5, marginBottom: 3, position: 'relative' }}>
                        <div style={{ display: "flex", width: "98%" }} className='obs-table-para'>
                          <div className="obs-edit-icon">
                            <span >
                              <FaRegEdit fill="#00ADEE" size={"10px"} />
                            </span>
                          </div>
                          <p style={{ minHeight: "39px", display: 'flex', alignItems: 'center' }}>{i?.remediationAction ? i?.remediationAction : "Not available"}</p>
                        </div>
                      </div>


                  }
                  {/* <div className='EditAddObsField'>
                    {console.log('editProcedure?.isEditClicked===============>>>>>>>>>>>..', editProcedure?.isEditClicked)}
                    {(editProcedure?.isEditClicked == true && editProcedure?.indexToEdit == index && editProcedure?.auditTestProcId == i?.auditTestProcId && editProcedure?.field == "RemAction") ?
                      <> <button className='obs-actions' onClick={() => { handleCloseEditProcedure() }}><AiOutlineClose size={"14px"} /></button>
                        <button className='obs-actions' onClick={() => { handleFinalEditProcedure() }}><FaPlus size={"14px"} /></button>
                      </>
                      :
                      <button className='obs-actions' onClick={() => { handleEditProcedureClick(rowData, index, "RemAction", i); }}><SlPencil size={"14px"} /></button>
                    }
                  </div> */}
                </div>
                {/* ============================================================================Comments tab============================================================================= */}
                <div onClick={() => { handleEditProcedureClick(rowData, index, "Comments", i,setEditProcedure); }} onBlur={() => handleFinalEditProcedure(editProcedure, setLoading,token,handleCloseEditProcedure, getObservationData, setSearchInput, setFailMessage, setSessionExpiredModal)} style={{ height: "100%", fontSize: 13, display: "flex", alignItems: "center", justifyContent: "left", padding: "5px", }}>
                  {
                    (editProcedure?.isEditClicked && editProcedure?.indexToEdit == index && editProcedure?.auditTestProcId == i?.auditTestProcId && editProcedure?.field == "Comments") ?
                      <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 3, flexDirection: "column" }}>
                        <textarea className='obs-table-textarea' style={{ width: "100%", resize: "none", boxShadow: "inset rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, inset rgba(60, 64, 67, 0.15) 0px 1px 3px 1px", border: '1px solid #00ADEE' }} placeholder='Enter Comments' onChange={(e) => handleEditchange("comments", { comment: e.target.value, evIndex: index, observationId: i?.observationId }, editProcedure, validateInput, setEditProcedure)}>{editProcedure.data?.evidences[index].comments}</textarea>
                        {!editProcedure.data?.evidences[index]?.isValidComment && <div style={{ color: "red", textAlign: "left", alignSelf: "flex-start" }}>Input cannot have leading whitespace</div>}

                      </div>
                      :
                      <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "left", gap: 5, marginBottom: 3, position: 'relative' }}>
                        <div style={{ display: "flex", width: "98%", }} className='obs-table-para'>
                          <div className="obs-edit-icon">
                            <span >
                              <FaRegEdit fill="#00ADEE" size={"10px"} />
                            </span>
                          </div>
                          <p style={{ minHeight: "39px", display: 'flex', alignItems: 'center' }}>{i?.comments ? i?.comments : "Not available"}</p>
                        </div>
                      </div>
                  }

                 
                </div>
              </div>
            );
          })
        )
      },
    },

    

  ];

 


  const getObservationData = async () => {
    try {
      setLoading(true)
      setDisableDownload(false)

      let observationListResp = await GET(Url.getAllCheckList.replace("{deptId}", dept?.value).replace("{year}", year?.value).replace("{quarter}", period?.value).replace("{type}", 1), token)
      if (observationListResp.SUCCESS) {
        if (observationListResp?.MESSAGE) {
          setLoading(false)
          // setOpenMsgModal(true)
          setFailMessage(observationListResp?.MESSAGE)
        }
        setData(observationListResp?.DATA)
        setCopyData(observationListResp?.DATA)


        setLoading(false)
        if (observationListResp?.MESSAGE) {
          setDisableDownload(true)
          //setOpenMsgModal(true)
          setFailMessage(observationListResp?.MESSAGE)
        }
      }
      else if (observationListResp?.STATUS == 401) {
        setLoading(false)
        setSessionExpiredModal(true)
        setFailMessage("Session expired");
      }
      else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false)

    }
    finally {
      setLoading(false);
    }
  }



  const [birthYearForCalender, setBirthYearForCalender] = useState(new Date());

  
  return (
    <div className='obs-main-div'>
      <div className='obs-uitility-container'>
        <div className='dept-selector'>

          <span >Year &nbsp; </span>
          <CustomYearPicker
            selectedDate={year?.value ? new Date(year?.value, 0) : null}
            // onDateChange={birthYearChange}
            onDateChange={(date) => {
              const parsedDate = new Date(date);
              birthYearChange(parsedDate, setBirthYearForCalender, setYear);
            }}
            isDisabled={disableDropdown}
            customStyles={customStylesyear}
          />

          <span style={{ marginLeft: 15 }}>Department &nbsp; </span>
          <Select
            options={options}
            styles={customStyles}
            isDisabled={disableDropdown}
            value={dept}
            isSearchable={false}
            onChange={(e) => { setDept(e); handleCloseEditProcedure(); }}
          />
          <span style={{ marginLeft: 15 }}>Period &nbsp; </span>
          <Select
            isSearchable={false}
            isDisabled={disableDropdown}
            options={periodOptions}
            styles={customStyles3}
            value={period}
            onChange={(e) => {
              setPeriod(e);
            }} />
        </div>
        <div className='obs-serch-download-cont'>
          <div style={{ pointerEvents: disableDownload ? "none" : "all", backgroundColor: disableDownload ? "#ccc" : "" }} data-testid="SiMicrosoftexcel" className='obs-download-btn' onClick={() => handleOpenDownloadModal(setDownloadAudit, setOpenDownloadModal, setFailMessage)}>
            <SiMicrosoftexcel /> <span>Export</span>
          </div>
          <div className='serchbox'>
            <BsSearch fill='#999999' />
            <input type="text" placeholder='Search by Control Reference ID' value={searchInput} onChange={(e) => setSearchInput(e.target.value)} />
          </div>
        </div>
      </div>
      <div className='obs-table-container'>
        <ThemeProvider theme={theme}>
          <MaterialTable
            localization={{ body: { emptyDataSourceMessage: <span className="no_data_found_table">No Audit Scheduled <span onClick={() => handleNavigate(navigate)} className="createAuditFunc">Create New Audit</span></span> } }}
            data={data}
            style={{ overflowX: "auto" }}
            columns={columns}
            icons={tableIconsObs}
            options={{
              toolbar: false,
              search: false,
              draggable: false,
              pageSizeOptions: [5, 10, 15, 20],
              pageSize: 10,
              headerStyle: {
                position: "sticky",
                top: -1,

                ...tableHeaderStyle,
              },
              maxBodyHeight: '66vh',
              minBodyHeight: '66vh'
            }}
            onChangePage={()=>handlePageChange(setToggle,toggle)}
          />
        </ThemeProvider>
      </div>
      <FailModal
        openFailModal={sessionExpiredModal}
        setOpenFailModal={setSessionExpiredModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() => handleSessionExpClose(navigate, setActive)}
        recallFunctiononClose={() => handleSessionExpClose(navigate, setActive)}
      />

      {/* modal for null data */}


      {/* ******************* Download modal *********************** */}
      <DownloadModal
        openFailModal={openDownloadModal}
        setOpenFailModal={setOpenDownloadModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() => handleDownloadButton(DownloadExcel, dept, year, period, setLoading, closeDownloadModal,setDownloadAudit, setOpenDownloadModal )}
        recallFunctiononClose={() => closeDownloadModal(setDownloadAudit, setOpenDownloadModal)}
        setDownloadAudit={setDownloadAudit}
        downloadAudit={donwloadAudit}
      />
      {/* ******************* Download modal end*********************** */}

    </div >
  )
}

export default Observations
